import moment from 'moment'

const timestampFormat = (componentName) => {
  switch(componentName) {
    case 'selectedblast': {
      return 'hh:mmA MMM DD YYYY'
    }
    case 'chip': {
      return 'ddd MMM Do, hh:mmA'
    }
    default: {
      return 'MMM DD YYY, hh:mma'
    }
  }
}
export const formatTimestamp = (componentName, ts) => {
  const momentObj = moment(ts)
  const format = timestampFormat(componentName.toLowerCase())
  return momentObj.format(format)
}

export const canStillCancel = (ts) => {
  const now = moment()
  const scheduledFor = moment(ts)

  return now.isSameOrBefore(scheduledFor)
}

export const createTempScheduledFor = (cancelled, createdAt) =>
  cancelled ?
    '' :
    moment(createdAt).clone().add(30, 'minutes').format()




// WEBPACK FOOTER //
// ./src/components/Messages/Blasts/time-tools.js